/** The address of a Code Quality report: `/workspaces/<id>/code-quality/<project id>`. */
const REPORT_PATH = /^\/workspaces\/[^/]+\/code-quality\/[^/]+\/?$/;

/** Where the app is, as the router keeps it; tests may leave the search out. */
interface PageLocation {
  pathname: string;
  search?: unknown;
}

/** Whether the page is a Code Quality report. */
export function isReportPath(pathname: string): boolean {
  return REPORT_PATH.test(pathname);
}

/**
 * Whether the page is a report opened from the Code Quality overview in Dashboards (`?from=dashboard`).
 * The sidebar marks the overview's node for it, not the workspace's Code Quality row.
 */
export function isOverviewReport(location: PageLocation): boolean {
  const search = location.search as { from?: unknown } | undefined;
  return isReportPath(location.pathname) && search?.from === 'dashboard';
}
